import React from 'react'
import ReactDOM from 'react-dom/client'
import './config/i18n'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { LicenseInfo } from '@mui/x-license-pro'
import { applyGlobalScripts } from './globalScripts'
import './styles/muiGlobalCss.scss'
import 'moment/dist/locale/es'
import { CookiesProvider } from 'react-cookie'
import MuiThemeProvider from './config/muiProvider/MuiProvider'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { registerGlobalErrorHandlers } from 'src/utils/globalErrorHandler'
import moment from 'moment'
import 'moment/locale/es'
import { initSentry } from 'src/config/sentry.config'
import { setupStore } from './redux'
import { AxiosInterceptorsWrapper } from './hooks'

applyGlobalScripts()

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE!)

moment.locale('es')
initSentry()

const store = setupStore()

registerGlobalErrorHandlers()
const appContainer = document.getElementById('root')
const root = ReactDOM.createRoot(appContainer!)

if (process.env.NODE_ENV === 'production') window.onbeforeunload = () => true

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <MuiThemeProvider>
        <CookiesProvider>
          <BrowserRouter>
            <AxiosInterceptorsWrapper>
              <App />
            </AxiosInterceptorsWrapper>
          </BrowserRouter>
        </CookiesProvider>
      </MuiThemeProvider>
    </Provider>
  )
}

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot?.accept('./App', renderApp)
}

renderApp()

reportWebVitals()
